import { DeleteAgentExecutionModal } from "@/components/ai/DeleteAgentExecutionModal";
import {
    ContextMenuItem,
    ContextMenuRoot,
    ContextMenuTrigger,
    ContextMenuPortal,
    ContextMenuContent,
} from "@/components/flexkit/ContextMenu";
import type { PlainAgentExecution } from "@/queries/agent-queries";
import { useState, type FC, type PropsWithChildren } from "react";
import { AgentExecution_Phase } from "gitpod-next-api/gitpod/v1/agent_pb";
import { useAgentExecutionActions } from "@/hooks/use-agent-execution-actions";

type AgentExecutionContextMenuProps = {
    agentExecution: PlainAgentExecution;
} & PropsWithChildren;

export const AgentExecutionContextMenu: FC<AgentExecutionContextMenuProps> = ({ agentExecution, children }) => {
    const [showDeleteAgentExecutionModal, setShowDeleteAgentExecutionModal] = useState(false);
    const { copyAgentExecutionId, handleStopAgentExecution } = useAgentExecutionActions(agentExecution);

    return (
        <>
            <ContextMenuRoot modal={true}>
                <ContextMenuTrigger>{children}</ContextMenuTrigger>
                <ContextMenuPortal>
                    <ContextMenuContent>
                        <ContextMenuItem onClick={copyAgentExecutionId} data-tracking-id="copy-conversation-id">
                            Copy conversation ID
                        </ContextMenuItem>
                        <ContextMenuItem
                            onClick={handleStopAgentExecution}
                            disabled={agentExecution.status?.phase === AgentExecution_Phase.STOPPED}
                            data-tracking-id="stop-conversation"
                        >
                            Stop conversation
                        </ContextMenuItem>
                        <ContextMenuItem
                            variant="destructive"
                            onClick={() => setShowDeleteAgentExecutionModal(true)}
                            data-tracking-id="delete-conversation"
                        >
                            Delete conversation
                        </ContextMenuItem>
                    </ContextMenuContent>
                </ContextMenuPortal>
            </ContextMenuRoot>
            <DeleteAgentExecutionModal
                agentExecution={agentExecution}
                open={showDeleteAgentExecutionModal}
                onClose={() => setShowDeleteAgentExecutionModal(false)}
            />
        </>
    );
};
